import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ShapeImg from '../../images/testimonial/img-6.png'
import BgImg from '../..//images/testimonial/testimonial-bg-3.jpg'
import quote from '../../images/testimonial/quote-2.svg'
import client1 from '../../images/testimonial/client/1.jpg'
import client2 from '../../images/testimonial/client/2.jpg'

const testimonials = [
    {
        id: '01',
        img: client1,
        Des: "Purus eget conctur massa amet. Hac diam suspendisse faucibus posuere dignim magna conum tristique.",
        Title: 'Leslie Alexander',
        Sub: "Marketing Coordinator",
    },
    {
        id: '02',
        img: client2,
        Des: "Purus eget conctur massa amet. Hac diam suspendisse faucibus posuere dignim magna conum tristique.",
        Title: 'John Abraham',
        Sub: "WEb Developer",
    },



]

const TestimonialS7 = (props) => {
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: true,
                    arrows: false,
                }
            },
        ]
    }

    return (
        <section className="wpo-testimonial-section-s13 section-padding ">
            <div className="testimonial-wrap" style={{ backgroundImage: `url(${BgImg})`}}>
                <Slider {...settings} className="testimonial-slider-s4">
                    {testimonials.slice(0, 2).map((testimonial, item) => (
                        <div className="item" key={item}>
                            <div className="content">
                                <div className="icon">
                                    <img src={quote} alt="quote" />
                                </div>
                                <h3>“{testimonial.Des}”</h3>
                                <h4>{testimonial.Title}</h4>
                                <span>{testimonial.Sub}</span>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
            <div className="image-right">
                <img src={ShapeImg} alt="" />
            </div>
        </section>

    );
};

export default TestimonialS7;


